<template>
  <div class="mb-3">
    <div class="d-flex justify-content-between">
      <h2 class="fw-light d-flex align-items-center mb-0">
        <router-link
          to="/home"
          class="d-flex align-items-center me-2"
          title="Voltar"
        >
          <i class="ph-caret-circle-left ph-2x" />
        </router-link>
        Gerenciar Consultas SQL
      </h2>
    </div>
  </div>
  <LoadingData v-if="isLoading" />
  <ListQueries
    v-else
    :queries="queriesSystem"
    :queriesTotvs="queriesTotvs"
    @saveQuery="saveQuery"
  />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import ListQueries from '@/components/admin/queries/ListQueries.vue'

export default {
  name: 'AdminQueries',

  components: {
    LoadingData,
    ListQueries,
  },

  data() {
    return {
      isLoading: true,
      queriesSystem: [],
      queriesByColigada: [],
      queriesTotvs: [],
    }
  },

  methods: {
    async getQueries() {
      try {
        this.isLoading = true
        this.queriesSystem = await this.$store.dispatch('getQueriesSystem')
        this.queriesTotvs = await this.$store.dispatch('getQueriesTotvs')
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getQueriesByColigada() {
      try {
        this.queriesByColigada = await this.$store.dispatch(
          'getQueriesByColigada',
        )
        this.setQueriesRelations()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    setQueriesRelations() {
      this.queriesSystem.forEach((querySystem) => {
        const queryByColigada = this.queriesByColigada.find(
          (query) => query.querySystemId === querySystem.id,
        )
        if (queryByColigada) {
          // Merge 2 objects
          Object.assign(querySystem, queryByColigada)
        }
      })
    },

    async saveQuery(query) {
      try {
        await this.$store.dispatch('saveQueryOnColigada', {
          querySystemId: query.id,
          queryTotvsId: query.queryTotvsId,
        })
        this.$root.$refs.notification.success(
          'Consulta atualizada com sucesso.',
        )
        this.queriesByColigada = await this.$store.dispatch(
          'getQueriesByColigada',
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getQueries()
    this.getQueriesByColigada()
  },
}
</script>
